import { Route, Routes, useNavigate } from "react-router-dom";
import { ContractManagement } from "./Components/Contracts/contractManagement";
import { ContractDetails } from "./Components/Contracts/contractDetails";
import { CustomerDashboard } from "./Components/Customers/customerDashboard";
import { InterestedCustomerRegistration } from "./Components/Leads/interestedCustomerRegistration";
import { UpdateCustomer } from "./Components/Customers/updateCustomer";
import { CustomerStatusChanged } from "./Components/Customers/CustomerStatusChanged";
import { CustomersList } from "./Components/Customers/customersList"
import { LeadInteractions } from "./Components/Interactions/leadIntersection";
import { InteractionForm } from "./Components/Interactions/interactionForm";
import { useLeadsStore } from "../../Stores/LeadAndCustomer/leadsStore";
import { Lead } from "shared-types";
import { NewCustomerPage } from "./Components/Customers/newCustomer";
import { EditContract } from "./Components/Contracts/editContract";
import { AddContract } from "./Components/Contracts/addContract";
import { LeadForm } from "./Components/Leads/leadForm";
import ClientSearchAndSelect from "./Components/upload";
import LeadSourcesPieChart from "./Components/Leads/LeadSourcesPieChart";
import { ExcelUpload } from "./Components/Leads/ UploadLeadsFile";
import { ExcelCUpload } from "./Components/Customers/UploadCustomersFile";

export const LeadAndCustomerRouting = () => {
    const nav = useNavigate();
    const {
        handleCreateInteraction
    } = useLeadsStore();
    return (
        <Routes>
            <Route path="" element={ <CustomersList/> }/>
            <Route path="customers" element={ <CustomersList/> }/>
            <Route path="customers/update" element={ <UpdateCustomer/> }/>
            <Route path="customers/new" element={ <NewCustomerPage/> }/>
            <Route path="leads/LeadSourcesPieChart" element={ <LeadSourcesPieChart/> }/>
            {/* <Route path="customers/:customerId" element={<CustomerDetails />} /> */ }
            <Route path="customers/updateStatus/:customerId" element={ <CustomerStatusChanged/> }/>
            <Route path="customers/:customerId/contract" element={ <ContractDetails/> }/>
            <Route path="customers/:customerId/dashboard" element={ <CustomerDashboard/> }/>
            <Route path="contracts" element={ <ContractManagement/> }/>
            <Route path="contracts/:customerId" element={ <ContractDetails/> }/>
            <Route path="contracts/new" element={ <AddContract/> }/>
            <Route path="leads" element={ <LeadInteractions/> }/>
            <Route path="leads/newLead" element={ <LeadForm/> }/>
            <Route path="contracts/customer/:customerId" element={ <ContractDetails/> }/>
            <Route path="contracts/addContract" element={ <AddContract/> }/>
            <Route path="contracts/edit/:contractId" element={ <EditContract/> }/>
            {/* <Route path="leads/:leadId" element={<DetailsOfTheLead />} /> */ }
            <Route path="customer/upload" element={ <ClientSearchAndSelect/> }/>
            <Route path="leads/interestedCustomerRegistration" element={ <InterestedCustomerRegistration/> }/>
            <Route path="leads/:leadId/addInteraction"
                   element={ <InteractionForm onSubmit={ (lead: Lead) => handleCreateInteraction(lead) }
                                              onCancel={ () => {
                                                  nav('/leadAndCustomer/leads')
                                              } }/> }/>

            <Route path="leads/UploadLeadsFile" element={ <ExcelUpload/> }/>
            <Route path="customers/UploadCustomersFile" element={ <ExcelCUpload/> }/>
        </Routes>
    );
};